export const NavLink = ({ onClick, children, className = "page-scroll" }) => {
  return (
    <li>
      <a href onClick={onClick} className={className}>
        {children}
      </a>
    </li>
  );
};
